import {Box, Columns, Pagination, Table, Tabs} from "react-bulma-components";
import React from "react";
import {readableDate} from "../../utils";
import Figure from "../Homepage/Figure";

export const InsuranceView = ({rentals, current, count, onPageChange, onViewChange, view, total_long_term, total_short_term}) => {

  return (
    <Box>
      <h1 className={"title"}>Upcoming Insurance Expiries</h1>
      <Columns>
            <Columns.Column>
                <Figure label="Total Estimated Long Term Weekly Rate" value={total_long_term} loaded={total_long_term}/>
            </Columns.Column>
            <Columns.Column>
                <Figure label="Total Estimated Short Term Weekly Rate" value={total_short_term} loaded={total_short_term}/>
            </Columns.Column>
      </Columns>
      <Tabs type="toggle" align="centered">
          <Tabs.Tab
            active={view === "all"}
            onClick={() => onViewChange("all")}
          >
            All
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "all_hire"}
            onClick={() => onViewChange("all_hire")}
          >
            All On Hire
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "weekly"}
            onClick={() => onViewChange("weekly")}
          >
            Weekly
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "onhires"}
            onClick={() => onViewChange("onhires")}
          >
            Upcoming Onhires
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "offhires"}
            onClick={() => onViewChange("offhires")}
          >
            Upcoming Offhires
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "insurance"}
            onClick={() => onViewChange("insurance")}
          >
            Insurance Expiries
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "unfinished_off"}
            onClick={() => onViewChange("unfinished_off")}
          >
            Unfinished Offhires
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "over_mileage"}
            onClick={() => onViewChange("over_mileage")}
          >
            Over Mileage
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "awaiting_quote"}
            onClick={() => onViewChange("awaiting_quote")}
          >
            Awaiting Estimate
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "quotes"}
            onClick={() => onViewChange("quotes")}
          >
            Quotes
          </Tabs.Tab>
          <Tabs.Tab
            active={view === "nr"}
            onClick={() => onViewChange("nr")}
          >
            Not Required
          </Tabs.Tab>
      </Tabs>
      <Table>
        <thead>
        <tr>
          <th>Registration</th>
          <th>Customer</th>
          <th>Make</th>
          <th>Model</th>
          <th>Insurancy Expiry</th>
        </tr>
        </thead>
        <tbody>
        {rentals.map((value, index) => (
          <tr
            className="clickable"
            onClick={() => window.open(`/editrental/${value.id}`, "_self")}
            key={value.id}
          >
            <td>{value.vehicle.registration}</td>
            <td>{value.customer.display_name}</td>
            <td>{value.vehicle.make.name}</td>
            <td>{value.vehicle.model.name}</td>
            <td>{readableDate(value.insurance_expiry)}</td>
          </tr>
        ))
        }
        </tbody>
      </Table>
      {/*<Pagination*/}
      {/*    showFirstLast={true}*/}
      {/*    onChange={page => onPageChange(page)}*/}
      {/*    current={current}*/}
      {/*    total={Math.ceil(count / 25)}*/}
      {/*  />*/}
    </Box>
  )
}